(() => {
  if (customElements.get('product-upsell-express')) return;
  class ProductUpsellExpress extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.sync = this.sync.bind(this);
      this.onClick = (event) => {
        if (!this.sync()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.addEventListener('click', this.onClick, true);
      this.form?.addEventListener('change', this.sync);
      this.form?.addEventListener('input', this.sync);
      this.observer = new MutationObserver((records) => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['value', 'data-id', 'data-selected', 'data-default-selected', 'data-variant-available', 'data-selection-config-changed'],
      });
      Promise.all([customElements.whenDefined('cart-drawer'), customElements.whenDefined('cart-drawer-upsell')])
        .then(() => { if (this.isConnected) this.sync(); });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick, true);
      this.form?.removeEventListener('change', this.sync);
      this.form?.removeEventListener('input', this.sync);
    }

    sync() {
      const wallet = this.querySelector('[data-product-wallet]');
      const fields = this.querySelector('[data-express-fields]');
      const status = this.querySelector('[data-product-express-status]');
      if (!wallet || !fields || !status) return false;
      wallet.inert = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer?.readUpsellDecision || !customElements.get('cart-drawer-upsell')) {
          throw new Error('Preparing express checkout…');
        }
        const mainId = this.form?.querySelector('[name="id"]')?.value;
        if (!/^\d+$/.test(mainId || '')) throw new Error('Select an available product option.');
        const items = [];
        const seen = new Set();
        for (const upsell of drawer.getToggleUpsells()) {
          // Empty-cart visual state is NOT a customer's opt-out.
          const saved = drawer.readUpsellDecision(drawer.lastKnownCart, upsell);
          const selected = upsell.dataset.selectionConfigChanged === 'true' || saved === null
            ? upsell.dataset.defaultSelected === 'true' : saved === 'true';
          if (!selected) continue;
          const id = upsell.dataset.id;
          if (!/^\d+$/.test(id || '') || upsell.dataset.variantAvailable === 'false') {
            throw new Error('An included add-on is unavailable. Review your cart options before checkout.');
          }
          if (id === mainId || seen.has(id)) continue;
          seen.add(id);
          items.push({ id, key: upsell.dataset.upsellKey || '',
            plan: upsell.querySelector('[name="selling_plan"]:not(:disabled)')?.value || '',
            label: upsell.querySelector('h3')?.textContent?.trim() || 'Add-on' });
        }
        const signature = JSON.stringify([mainId, items]);
        if (signature !== this.signature) {
          const fragment = document.createDocumentFragment();
          const append = (name, value) => {
            const input = document.createElement('input');
            input.type = 'hidden'; input.name = name; input.value = value;
            input.dataset.expressAdditionalItem = 'true';
            fragment.append(input);
          };
          items.forEach((item, index) => {
            const prefix = `shopify-additional-items[${index + 1}]`;
            append(`${prefix}[id]`, item.id);
            append(`${prefix}[quantity]`, '1');
            append(`${prefix}[parent_id]`, mainId);
            // Native wallets JSON.parse the entire properties field and expect
            // line-item properties as key/value entries, not nested form keys.
            append(`${prefix}[properties]`, JSON.stringify([
              { key: '_theme_upsell_key', value: item.key },
            ]));
            if (item.plan) append(`${prefix}[selling_plan]`, item.plan);
          });
          fields.replaceChildren(fragment);
          this.signature = signature;
        }
        const message = items.length ? `Includes: ${items.map(item => item.label).join(', ')}` : '';
        if (status.textContent !== message) status.textContent = message;
        wallet.inert = false;
        return true;
      } catch (error) {
        fields.replaceChildren();
        this.signature = null;
        if (status.textContent !== error.message) status.textContent = error.message;
        return false;
      }
    }
  }
  customElements.define('product-upsell-express', ProductUpsellExpress);
})();
